import { render, staticRenderFns } from "./EditSocialContact.vue?vue&type=template&id=6ff9b375&"
import script from "./EditSocialContact.vue?vue&type=script&lang=js&"
export * from "./EditSocialContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports